import _ from 'underscore';
import ko from 'knockout';
import { TargetingScope, TargetingLevel } from '@bingads-webui-campaign/targeting-settings-scaffolds';

export default class ViewModel {
  constructor(options = {}) {
    this.options = options;
    this.scope = options.scope;
    this.level = options.level;
    this.criterions = options.criterions;
    this.showBidMode = ko.observable(true);
    this.selectedCampaign = ko.observable();
    this.selectedAdgroup = ko.observable();
    this.shouldShowCampaignAdgroupSelector = ko.computed(() =>
      (_.isUndefined(this.options.adgroupId) || !options.hideSelectorControl) &&
        (this.scope === TargetingScope.Account ||
          (this.scope === TargetingScope.Campaign && this.level === TargetingLevel.AdGroup)));
    this.shouldShowLocationsEditor = ko.computed(() =>
      this.selectedCampaign() || this.selectedAdgroup());
    this.shouldEnableSave = ko.computed(() =>
      this.showBidMode() && (this.selectedCampaign() || this.selectedAdgroup()));
    this.shouldShowHighLantencyNote = ko.observable(false);
  }
}
